// extracted by mini-css-extract-plugin
module.exports = {"Appointment":"Appointment_Appointment__JlQ7_","Appointment__Content":"Appointment_Appointment__Content__uTUnZ"};